/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface AttachTaskResponseContent
 */
export interface AttachTaskResponseContent {
    /**
     * 
     * @type {string}
     * @memberof AttachTaskResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the AttachTaskResponseContent interface.
 */
export function instanceOfAttachTaskResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function AttachTaskResponseContentFromJSON(json: any): AttachTaskResponseContent {
    return AttachTaskResponseContentFromJSONTyped(json, false);
}

export function AttachTaskResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachTaskResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function AttachTaskResponseContentToJSON(value?: AttachTaskResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

